import React from 'react'
import { Select } from 'components/forms/Selects'
import { selectedFacilityAppointmentTime } from 'utils/accessorialHelpers'

export const FacilitySelect = ({ detention, editMode, onSelect, setSelectedStop, stops }) => {
  const onChange = ({ value }, id) =>
    onSelect(current => {
      const selectedFacilityStop = stops.find(stop => stop.facility.shipperFacilityUuid === value)
      if (selectedFacilityStop) setSelectedStop(selectedFacilityStop)
      const newState = { ...current, ...{ [id]: value } }
      return newState
    })
  const facilityOptions = stops.map(stop => {
    const stopType = `${stop.type.charAt(0).toUpperCase()}${stop.stopSequence}`
    const stopName = `${stop.facility.city}, ${stop.facility.stateCode}`
    return {
      label: `${stopType}: ${stopName}`,
      value: stop.facility.shipperFacilityUuid,
      name: `${stopName} (${stopType})`,
    }
  })
  const indexedFacilityOptions = facilityOptions.reduce(
    (indexed, fo) => ({ ...indexed, [fo.value]: fo }),
    {}
  )
  const appointmentTime = selectedFacilityAppointmentTime(stops, detention)
  const stopName = indexedFacilityOptions[detention.shipperFacilityUuid]
    ? indexedFacilityOptions[detention.shipperFacilityUuid].name
    : ''

  return (
    <>
      <div className='row'>
        <div className='col-md-12 pl0'>
          {!editMode ? (
            <Select
              id='shipperFacilityUuid'
              label='Facility'
              value={indexedFacilityOptions[detention.shipperFacilityUuid]}
              options={facilityOptions}
              onChange={onChange}
            />
          ) : (
            <>
              <strong>Stop </strong>
              <span>{stopName}</span>
            </>
          )}
        </div>
      </div>
      {detention.shipperFacilityUuid && (
        <div className='row'>
          <div className='col-md-12 pl0'>
            <strong>Appointment </strong>
            <span>{appointmentTime}</span>
          </div>
        </div>
      )}
    </>
  )
}
